import { UIStrings } from '../models/UIStrings.ts';

import { useOptionalContent } from './useOptionalContent.ts';
import { UIStringsContent } from './selectors';

export const useUIString = (key: keyof UIStrings, defaultValue: string = '') => {
  const { data } = useOptionalContent(UIStringsContent);

  return (data && key in data ? data[key] : undefined) ?? defaultValue;
};
